/**
 * Display formatting.
 *
 * Formatting never changes a stored value. Every rounded figure in the UI is
 * shown next to, or expandable to, its unrounded source.
 */

export function formatNumber(value: number, decimals = 3): string {
  if (!Number.isFinite(value)) return '—';
  return value.toLocaleString('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: decimals,
  });
}

/** Full precision, for the "exact mathematical result" line. */
export function formatExact(value: number): string {
  if (!Number.isFinite(value)) return '—';
  return String(value);
}

export function formatDays(value: number, decimals = 3): string {
  if (!Number.isFinite(value)) return '—';
  return `${formatNumber(value, decimals)} days`;
}

export function formatSignedDays(value: number, decimals = 2): string {
  if (!Number.isFinite(value)) return '—';
  if (Math.abs(value) < 5e-3) return '—';
  const sign = value > 0 ? '+' : '−';
  return `${sign}${formatNumber(Math.abs(value), decimals)} d`;
}

export function formatDate(iso?: string): string {
  if (!iso) return '—';
  const parsed = new Date(`${iso}T00:00:00Z`);
  if (Number.isNaN(parsed.getTime())) return '—';
  return parsed.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone: 'UTC',
  });
}

export function formatTimestamp(iso: string): string {
  const parsed = new Date(iso);
  if (Number.isNaN(parsed.getTime())) return iso;
  return parsed.toISOString().replace('T', ' ').slice(0, 19) + ' UTC';
}
